export * from './hasPermission/hasPermission.pipe';
